import {
  ArchiveWorkAreaDocument,
  ArchiveWorkAreaMutation,
  ArchiveWorkAreaMutationVariables,
  GetWorkAreasDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useArchiveWorkArea = () => {
  const [executeMutation] = useMutation(ArchiveWorkAreaDocument, {
    extractorFn: (data: ArchiveWorkAreaMutation) =>
      data.locationsMutations.archiveLocationsWorkArea,
  })

  const archiveWorkArea = async (variables: ArchiveWorkAreaMutationVariables) => {
    return executeMutation({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetWorkAreasDocument,
        },
      ],
    })
  }

  return {
    archiveWorkArea,
  }
}
